<template>
  <el-row>
    <el-col :span="24">
      <h1>A Simple FlowChart Libary Base On JsPlumb</h1>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: 'Header'
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue